export default {
  color: 'text',
  fontFamily: 'body',
  lineHeight: 'body',
  fontWeight: 'body',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
};

export const heading = {
  color: 'text',
  fontFamily: 'heading',
  lineHeight: 'heading',
  fontWeight: 'heading',
};

export const heroTitle = {
  // unused in Rink designs, but in RC
  variant: 'text.heading',
  fontSize: [6, 9],
  letterSpacing: 0,
};

export const heroTitleSmall = {
  // needs to be renamed, I don't see it in any designs
  variant: 'text.heading',
  fontSize: [6, 8],
  letterSpacing: 3,
};

export const featuredStoryTitleSmall = {
  variant: 'text.heading',
  fontSize: 5,
  fontWeight: 'medium',
  letterSpacing: '-0.63px',
  lineHeight: '28px',
};

export const mediumTitle = {
  variant: 'text.heading',
  fontSize: 6,
  letterSpacing: 0,
  fontFamily: 'headingSecondary',
};

export const smallTitle = {
  variant: 'text.heading',
  fontSize: 4,
  letterSpacing: 0,
  fontFamily: 'headingSecondary',
};

export const body = {
  variant: 'text.default',
};

export const largeP = {
  // rink hero caption block
  variant: 'text.body',
  fontSize: 4,
  letterSpacing: 1,
};

export const mediumP = {
  // rink directions/hours
  variant: 'text.body',
  fontSize: 3,
  letterSpacing: 1,
};

export const smallP = {
  // rink carousel caption
  variant: 'text.body',
  fontSize: 2,
  letterSpacing: 2,
};

export const articleP = {
  //article page paragraph
  variant: 'text.body',
  lineHeight: 1.75,
  fontSize: 3,
  letterSpacing: 1,
};

export const ticketTitleBase = {
  variant: 'styles.h3',
  mx: 2,
  my: 3,
  fontFamily: 'headingSecondary',
};

export const ticketDescriptionBase = {
  variant: 'styles.smallP',
  m: 2,
};

export const copyright = {
  fontSize: [0, 1],
};

export const ticketPrice = {
  fontFamily: 'body',
  fontWeight: 'heading',
  fontSize: [3, null, 5],
  lineHeight: 1,
  letterSpacing: 1,
};

export const ticketPriceSmall = {
  fontFamily: 'body',
  fontWeight: 'body',
  fontSize: 1,
  lineHeight: 1,
  letterSpacing: 1,
};

export const eyebrow = {
  variant: 'text.body',
  fontSize: 2,
  letterSpacing: 3,
  fontWeight: 'medium',
  color: 'text',
  opacity: '0.75',
};

export const categoryEyebrow = {
  variant: 'text.eyebrow',
  mb: 3,
  fontSize: 3,
  fontWeight: 'regular',
  color: 'accentSecondary',
  opacity: '1',
};

export const eventListTitle = {
  variant: 'text.heading',
  fontSize: [4, 4, 5],
  fontWeight: 'medium',
  lineHeight: ['26px', '26px', '33px'],
  overflowWrap: 'break-word',
  wordWrap: 'break-word',
};

export const featuredEventTitle = {
  variant: 'text.heading',
  fontSize: 7,
  lineHeight: '51px',
  fontWeight: 'medium',
  letterSpacing: '-1px',
};

export const featuredStoryEyebrow = {
  variant: 'text.eyebrow',
  fontFamily: 'headingSecondary',
  mb: [2, 3],
  fontSize: 1,
  fontWeight: 'medium',
  color: 'heroBackground',
  opacity: '1',
};

export const giftGuideEyebrow = {
  variant: 'text.eyebrow',
  fontFamily: 'headingSecondary',
  textTransform: 'uppercase',
  fontSize: 1,
  fontWeight: 'regular',
  letterSpacing: 5,
  opacity: '1',
};

export const hoursAndDirections = {
  variant: 'text.body',
  fontSize: [2, 3],
  color: 'text',
};

/** Text that appears underneath the `MenuBar` Rock Center logo. */
export const rockCenterPageName = {
  variant: 'text.body',
  color: 'pageName',
  transition: 'color 0.7s ease-in-out',
  fontSize: [2, null, 3],
  fontWeight: 'medium',
  whiteSpace: 'nowrap',
  lineHeight: 1,
};

/** Text that appears underneath the `MenuBar` Rainbow Room logo. */
export const rainbowRoomPageName = {
  variant: 'text.rockCenterPageName',
  fontSize: [2, 3, 4, 5],
};

export const imageCalloutTitle = {
  variant: 'text.heading',
  fontSize: [5, 6, 7],
  fontFamily: 'headingSecondary',
  letterSpacing: 0,
  mb: [2, null, 3],
};

export const selectNavigationTitle = {
  // for select navigation
  variant: 'text.body',
  color: 'primary',
  fontSize: [2, 3],
};

export const faqItemTitle = {
  variant: 'styles.h3',
  fontFamily: 'headingSecondary',
  fontWeight: 'regular',
};

export const footerHeading = {
  variant: 'styles.h5',
  color: 'primary',
};

export const footerFirstSectionHeading = {
  variant: 'styles.h5',
  color: 'primary',
  fontSize: 3,
};

export const journeyToTheTopHeading = {
  variant: 'styles.h5',
  fontSize: 4,
  fontFamily: 'headingSecondary',
  fontWeight: 'regular',
  color: 'text',
};

export const leasingContactTitle = {
  fontSize: [4, 5],
  fontWeight: 'heading',
  lineHeight: 'heading',
};

export const storyAuthor = {
  variant: 'text.body',
  fontWeight: 'medium',
  fontSize: 1,
  letterSpacing: 5,
  color: 'accent',
  textAlign: 'center',
  textTransform: 'uppercase',
};

export const featuredEventMarquee = {
  variant: 'text.heading',
  writingMode: ['initial', null, null, 'vertical-lr'],
  textOrientation: ['initial', null, null, 'upright'],
  fontSize: [7, null, 10],
  flex: [null, '1 0 auto'],
};

export const accessibilityHeading = {
  variant: 'text.heading',
  fontSize: [4, 6],
  fontFamily: 'headingSecondary',
};

export const torAccessibilityItemHeading = {
  variant: 'text.heading',
  fontSize: [4, 5],
  fontFamily: 'headingSecondary',
};

export const torAccessibilityPageHeading = {
  variant: 'text.heading',
  fontSize: [4, 6],
  fontFamily: 'headingSecondary',
};

export const menuHeading = {
  color: 'accent',
  fontFamily: 'headingSecondary',
  fontWeight: 'medium',
  letterSpacing: '0.08em',
  fontSize: 2,
  lineHeight: '26px',
  whiteSpace: 'nowrap',
  textTransform: 'uppercase',
};

export const ticketButtonLabel = {
  mx: 2,
};

export const ticketButtonLabelSmall = {
  mx: '10px',
  fontSize: 1,
};

export const search = {
  '& > b': {
    fontWeight: 'medium',
  },
  '& > br': {
    display: 'none',
  },
};

export const largePrivateEventSpec = {
  variant: 'text.heroTitleSmall',
  lineHeight: 'body',
  fontFamily: 'headingSecondary',
  fontSize: 8,
};

export const eventPageDate = {
  fontWeight: [400, 400, 500],
  fontFamily: 'body',
  fontSize: ['12px', '12px', 8],
  lineHeight: ['16px', '16px', '63px'],
  letterSpacing: '1.5px',
};

export const eventListItemLocationSmall = {
  fontWeight: ['regular', 'regular', 'medium'],
  letterSpacing: '-0.39px',
  fontSize: ['12px', '12px', 3],
  lineHeight: '25px',
};

export const mediumPrivateEventSpec = {
  variant: 'text.heading',
  fontSize: 7,
  letterSpacing: 3,
  lineHeight: 'body',
  fontFamily: 'headingSecondary',
};

export const smallPrivateEventSpec = {
  variant: 'text.heading',
  fontSize: [5, 6],
  letterSpacing: 3,
  lineHeight: 'body',
  fontFamily: 'headingSecondary',
};

export const formError = {
  variant: 'text.mediumP',
  color: 'error',
  fontStyle: 'italic',
};

export const introTextHeading = {
  variant: 'text.heading',
  fontFamily: 'headingSecondary',
  fontSize: [6, 9],
};

export const executiveTitle = {
  opacity: 0.5,
  fontSize: 3,
};

/** A text entry in an alphabetical or numeric group list. */
export const groupList = {
  variant: 'text.default',
  display: 'inline-block',
  fontWeight: 'book',
  fontSize: 1,
  py: 1,
  pl: 3,
  pr: 4,
  color: 'textDisabled',
};

export const storyDate = {
  fontFamily: 'headingSecondary',
  fontWeight: 'medium',
  my: 3,
  textTransform: 'uppercase',
  fontSize: [0, 1],
  color: 'heroBackground',
};

export const storyTopic = {
  fontWeight: 'regular',
  textTransform: 'uppercase',
  fontSize: 1,
  letterSpacing: 5,
  color: 'heroBackground',
};

export const ticketsHeading = {
  variant: 'text.heading',
  fontFamily: 'headingSecondary',
  fontSize: [5, 7],
  lineHeight: ['28px', '51.75px'],
};

export const ticketsHeadingSmall = {
  ...ticketsHeading,
  fontSize: 5,
};

export const ticketsPriceSticky = {
  variant: 'text.heading',
  fontFamily: 'headingSecondary',
  fontSize: 5,
  lineHeight: ['31px', '26px'],
};

export const ticketsPriceSmall = {
  variant: 'text.heading',
  fontFamily: 'headingSecondary',
  fontSize: [1, 3],
};

// it's safe to modify this variant since it's onl;y used at the NewTicketLine component
export const ticketsPriceMedium = {
  variant: 'text.heading',
  fontFamily: 'headingSecondary',
  fontSize: [3],
  lineHeight: 1.46,
  letterSpacing: '-0.6px',
};

export const taxHeading = {
  variant: 'text.body',
  fontWeight: 'medium',
  fontSize: 3,
};

export const taxHeadingSticky = {
  variant: 'text.body',
  fontWeight: 'medium',
  fontSize: 1,
};

export const buyTicketsBarTitle = {
  variant: 'text.mediumTitle',
  fontSize: [3, 5],
  lineHeight: ['23px', '26px'],
};

export const buyTicketsConfirmationTitle = {
  variant: 'text.mediumTitle',
  fontSize: [6, 8],
};

export const hidden = {
  clip: 'rect(0,0,0,0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: '0',
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
};

export const storyLeftMenuHeading = {
  variant: 'text.body',
  fontWeight: 'medium',
  fontSize: 1,
  letterSpacing: 2.48,
  textTransform: 'uppercase',
};

export const ticketArrivalInstructionsSubHeading = {
  'variant': 'text.heading',
  'fontSize': [2, 3],
  'fontFamily': 'headingSecondary',
  'fontWeight': '500',
  'lineHeight': '150%',
  '@media print': {
    fontSize: 2,
    lineHeight: 1,
  },
};

export const ticketArrivalInstructions = {
  'variant': 'text.body',
  'paddingBottom': '32px',
  'fontSize': [2, 3],
  'fontWeight': '400',
  'lineHeight': '150%',
  '@media print': {
    paddingBottom: '16px',
    fontSize: 1,
    lineHeight: 1,
  },
};

export const strong = {
  'variant': 'text.body',
  'fontSize': [2, 3],
  'fontWeight': '500',
  'lineHeight': '150%',
  'display': 'inline',
  '@media print': {
    fontSize: 1,
    lineHeight: 1,
  },
};

export const h1 = {
  fontFamily: 'headingSecondary',
  fontSize: ['32px', '60px'],
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '113%',
  letterSpacing: ['-0.32px', '-0.6px'],
};

export const h2 = {
  fontFamily: 'headingSecondary',
  fontSize: 46,
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '120%',
  letterSpacing: '-0.92px',
};

export const bodyEmphasis = {
  fontFamily: 'headingSecondary',
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '150%',
};

export const uiButton = {
  fontFamily: 'headingSecondary',
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: '500',
  letterSpacing: '2px',
  textTransform: 'uppercase',
};
